import {getAbsoluteUrl} from "../../utils/urlUtill";
import {CustomerFilter} from "../../customers/model/CustomerFilter";
import {convertDateTimeToFormat} from "../../utils/DateUtils";
import {IHttpPromise, IHttpResponse, IPromise} from "angular";
import {UserDto} from "../../users/model/User";
import {Customer} from "../../customers/model/Customer";
import {SendGridContactListOptions} from "../../customers/model/SendGridContactListOptions";
import {CustomerCsvExportDescriptor} from "../../customers/model/CustomerCsvExportDescriptor";

export class CustomerService {
    private $http: ng.IHttpService;

    constructor($http) {
        this.$http = $http;
    }

    findFilteredCustomers(amount, page, filter: CustomerFilter): IHttpPromise<any> {
        filter.fundedDateUntil = convertDateTimeToFormat(filter.fundedDateUntil);
        filter.fundedDateStartingFrom = convertDateTimeToFormat(filter.fundedDateStartingFrom);
        return this.$http({
                method: 'POST',
                url: getAbsoluteUrl('api/customer/filtered'),
                params: {
                    page: (page - 1),
                    pageSize: amount
                },
                data: filter

            }
        )
    }

    findLoanOfficerCustomers = (user: UserDto): IPromise<IHttpResponse<Customer[]>> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/customer'),
            params: {
                lo_email: user.email
            }
        })
    };

    deleteCustomer = (id): IHttpPromise<any> => this.$http({
        method: 'DELETE',
        url: getAbsoluteUrl(`customer/temporary/${id}`)
    });

    permanentlyDeleteCustomer = (id): IHttpPromise<any> => this.$http({
        method: 'DELETE',
        url: getAbsoluteUrl(`customer/permanently/${id}`)
    });

    getEnums(): IHttpPromise<any> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('enums')
        });
    }

    createSendgridContactsListFromFilteredCustomers = (sendGridOptions: SendGridContactListOptions, filter: CustomerFilter) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/contact_list'),
        data: {
            sendGridOptions: sendGridOptions,
            contactFilter: filter
        },
        params: {
            filtered: true
        }
    });

    createSendgridContactsListFromContactIds = (sendGridOptions: SendGridContactListOptions, selectedCustomersIds: number[]) =>
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/contact_list'),
            data: {
                sendGridOptions: sendGridOptions,
                customersIds: selectedCustomersIds
            },
            params: {
                personal: true
            }
        });

    downloadCsvExport = (filter: CustomerFilter, type: string) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/csv/' + type),
        data: filter,
        transformResponse: [data => data],
        params: {
            use_filter: true
        }
    });

    downloadCsvExportForCustomers = (selectedIds: number[], type: string) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/csv/' + type),
        data: selectedIds,
        transformResponse: [data => data],
        params: {
            use_ids: true
        }
    });

    loadFieldDescriptions(): IPromise<IHttpResponse<CustomerCsvExportDescriptor[]>> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/csv/customers/details')
        });
    }
}